<template>
     <div
      v-if="showProjectModal"
      class="modal-overlay"
      @click.self="$store.dispatch('showProjectModal', {showModal: false})"
    >
      <div class="modal-content">
        <h2>{{ !editingProject.id ? "Create Project" : "Edit"}}</h2>
        <div class="input-div">
          <span class="d-flex label w-100">Project Name</span>
          <input
            type="text"
            placeholder="Project Name"
            class="project-name-input w-100"
            v-model="editingProject.name"
          />
        </div>
      
        <div class="d-flex input-div justify-content-between">
          <span class="d-flex label w-100">Project Color</span>
          <div :class="getProjectColorClass(editingProject.color, color)" :style="{background: color}" v-for="color,index in projectColors" @click="editingProject.color = color" :key="index">
            <CheckIcon v-if="editingProject.color === color" />
          </div>
        </div>
        <div class="modal-actions">
          <button class="secondary-invert" @click="$store.dispatch('showProjectModal', {showModal: false})">Cancel</button>
          <button class="primary" @click="emitAddProject">{{ !editingProject.id ? "Add" : "Save"}}</button>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import CheckIcon from "./icons/CheckIcon.vue";
export default {
  name: "LeftNav",
  emits: ["createProject", "projectSelected"],
  components: {
    CheckIcon
  },
  computed: {
      ...mapGetters(['projects','selectedProject','connections','showProjectModal','editingProject']),
      filteredProjects() {
          return this.projects.filter((project) => !project.date_deleted); // Filter the projects getter
      },
      filteredConnections() {
        console.log(this.connections);
      // Filter connections based on category 'Email'
      return this.connections.filter(connection => connection.category === 'Email');
    },
  },
  data() {
    return {
      projectColors: [
      "#d63333",  // Red
      "#FF6B6B", // Vivid Red
      "#FF9F43", // Bright Orange
      "#FFC107", // Bold Yellow
      "#28C76F", // Fresh Green
      "#48B587", // Emerald Green
      "#00CFE8", // Electric Cyan
      "#007BFF", // Strong Blue
      "#7367F0", // Royal Purple
      "#D63384", // Magenta Pink
    ],
    };
  },
  methods: {
    ...mapActions("auth", ["logout", "isAuthenticated"], "editProject"),
    getProjectColorClass(projectColor, color){
      if(color === projectColor){
        return "project-color-option-selected";
      }else{
        return "project-color-option";
      }
    },
    emitAddProject() {
        this.$store.dispatch('editProject', this.editingProject);
        this.$store.dispatch('showProjectModal', {showModal: true, editingProject: {color: `#48B587`}})
    },

  },
};
</script>

<style scoped>
.project-color-option,
.project-color-option-selected {
  width: calc(10% - 1rem);
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
}
.project-color-option-selected {
  border: 2px solid var(--black-colo-08);
}
.project-color-option-selected svg {
  stroke: var(--black-colo-08);
}

.input-div {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

/* Overlay */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center; align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  background: var(--Theme-Color-Secondary-Black); /* or var(--Theme-Color-Secondary-Black) */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
  display: flex;
  flex-direction: column;
}
.modal-content h2 {
  margin-top: 0;
  font-size: 20px;
  color: var(--white-color);
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.modal-actions .secondary,
.modal-actions .primary {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

/* Project Name Input */
.project-name-input {
  color: var(--dark-colo-a0);
  display: block;
  background-color: transparent;
  border: 1px solid #5a5a5a; /* or var(--Border-Color-Primary) */
  border-radius: 5px;
  padding: 10px;
  font-size: 1rem;
  margin: 10px 0;
}
.project-name-input::placeholder {
  color: #a6a6a6;
  opacity: 1;
}

</style>